import React, { useState, useEffect } from "react";
import { Button, Modal, Loader, Dimmer, ButtonProps } from "semantic-ui-react";
import CustomLoader from "../CustomLoader";

export interface IOnSuccess {
    content: string;
    disabled?: boolean;
    loading?: boolean;
    func: () => void;
}

interface IModalAppProps {
    title: string | JSX.Element;
    content?: any;
    trigger?: ButtonProps;
    open?: boolean;
    handleOpen?: () => void;
    handleClose?: () => void;
    onOpen?: () => void;
    onSuccess?: IOnSuccess;
    loading?: boolean;
    cancelText?: string;
}

const ModalApp: React.FC<IModalAppProps> = ({ title, content, trigger, open, handleOpen, handleClose, onSuccess, onOpen, cancelText, loading }) => {

    const [openModal, setOpenModal] = useState<boolean | undefined>(false);

    useEffect(() => { setOpenModal(open); }, [open]);

    const BtnTrigger = trigger && <Button
        {...trigger}
        onClick={handleOpen}
    />;

    return (
        <Modal
            centered={false}            
            dimmer="inverted"
            trigger={BtnTrigger}
            open={openModal}
            onOpen={onOpen}
            closeOnDimmerClick={false}
            header={loading ? "" : title}
            content={loading
                ? <Modal.Content>
                    <CustomLoader />
                </Modal.Content>
                : content}
            actions={loading
                ? []
                : [{
                    content: cancelText || "Cancelar",
                    key: "cancelar",
                    onClick: handleClose
                },
                onSuccess &&
                {
                    content: onSuccess.content,
                    key: onSuccess.content,
                    onClick: onSuccess.func,
                    icon: "checkmark",
                    color: "pink",
                    labelPosition: "left",
                    disabled: onSuccess.disabled,
                    loading: onSuccess.loading
                }]}
        />
    )
}

export default ModalApp;
